import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from 'react'
import type { FrontendSourceType } from '../const/SourceType'

export interface VideoSource {
  type: FrontendSourceType
  // For SourceType.WEBRTC this is the shareId, not a playable URL.
  url: string
  // Only meaningful for OutputType.WEBSOCKET — the instance's resolved
  // ffmpeg encoder names, used to pick the MediaSource SourceBuffer codec.
  videoCodec?: string | null
  audioCodec?: string | null
}

interface PlayerContextValue {
  videoSource: VideoSource | null
  setVideoSource: Dispatch<SetStateAction<VideoSource | null>>
}

const PlayerContext = createContext<PlayerContextValue | undefined>(undefined)

export const PlayerProvider = ({ children }: { children: ReactNode }) => {
  const [videoSource, setVideoSource] = useState<VideoSource | null>(null)

  return <PlayerContext value={{ videoSource, setVideoSource }}>{children}</PlayerContext>
}

export const usePlayer = (): PlayerContextValue => {
  const context = useContext(PlayerContext)
  if (!context) {
    throw new Error('usePlayer must be used within an PlayerProvider')
  }
  return context
}
